// -- [Canonical site metadata for SEO, Open Graph, and structured data]

export const SITE_URL = 'https://www.drivible.com/'

export const SITE_TITLE = 'Drivible – Document Storage and Management'

export const SITE_TAGLINE = 'For Australian Car Dealerships'

export const SITE_DESCRIPTION =
  'Document storage and management for Australian car dealerships. Cloud eSign and ePayments — cut paperwork and pass audits faster.'

export const OG_TITLE = SITE_TITLE

export const OG_DESCRIPTION =
  'Document storage and management for Australian car dealerships. Trusted by 40+ dealers storing 4.7M+ pages. Cut paperwork today.'

export const HERO_SHARE_IMAGE_FILENAME =
  'Paper to Scanner to Drivible - With Transparency - Resized for Web.webp'

export const HERO_SHARE_IMAGE_PATH = `/images/${encodeURIComponent(HERO_SHARE_IMAGE_FILENAME)}`

export const HERO_SHARE_IMAGE_WIDTH = 2144

export const HERO_SHARE_IMAGE_HEIGHT = 650

export const OG_IMAGE_URL = `${SITE_URL.replace(/\/$/, '')}${HERO_SHARE_IMAGE_PATH}`

export const SITE_LOGO_URL = `${SITE_URL.replace(/\/$/, '')}/logos/drivible-logo.png`

export const ORGANIZATION_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Drivible',
  url: SITE_URL,
  logo: SITE_LOGO_URL,
  description: SITE_DESCRIPTION,
  areaServed: {
    '@type': 'Country',
    name: 'Australia',
  },
} as const

export const WEB_SITE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Drivible',
  url: SITE_URL,
  description: SITE_DESCRIPTION,
  publisher: {
    '@type': 'Organization',
    name: 'Drivible',
    logo: SITE_LOGO_URL,
  },
} as const
